export const newsList = [
  {
    id: "n1",
    title: "《长夜将尽》正式杀青 筱田优挑战全新冷峻角色",
    excerpt:
      "历经三个月的紧张拍摄，筱田优主演的电影《长夜将尽》于本月正式杀青，影片中她将诠释一位游走在灰色地带的关键人物。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20moody%20city%20alley%20at%20night%20with%20rain%20and%20soft%20neon%20reflections%2C%20film%20noir%20atmosphere%2C%20mysterious%20and%20elegant%2C%20muted%20indigo%20tones%20with%20warm%20highlights%2C%20editorial%20cinematography%20still&width=800&height=500&seq=news-c01&orientation=landscape",
    date: "2025-09-28",
    category: "影视动态",
    tags: ["长夜将尽", "杀青", "电影"],
    views: 18420,
    hot: 98,
    content: [
      { type: "p", text: "由陈屿执导，筱田优领衔主演的电影《长夜将尽》日前在南方滨海城市顺利杀青，片方同步公布了首张概念剧照与主创阵容。" },
      { type: "h3", text: "一个不断逼近真相的角色" },
      { type: "p", text: "在这部影片中，筱田优饰演的角色游走在真相与谎言的边缘，需要大量依靠眼神与肢体去传递情绪。为贴近人物，她在开拍前进行了为期一个月的体能与方言训练。" },
      { type: "p", text: "导演陈屿表示，这次合作让他看到了筱田优身上更沉静、更锋利的一面，人物的克制与爆发构成了整部影片的情绪核心。" },
      { type: "h3", text: "预计明年与观众见面" },
      { type: "p", text: "《长夜将尽》目前进入后期制作阶段，预计将于明年上半年在院线上映，同时计划参与多个国际影展。" },
    ],
    relatedWorkIds: ["w3"],
  },
  {
    id: "n2",
    title: "科幻新作《光年之外》首曝预告 视觉风格引发热议",
    excerpt:
      "筱田优与林澈再度携手出演的科幻电影《光年之外》发布首支预告，宏大而诗意画面与克制的叙事让影迷期待值拉满。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20science%20fiction%20space%20scene%20with%20soft%20nebula%20clouds%20and%20a%20small%20lone%20silhouette%2C%20deep%20indigo%20and%20amber%20gradient%20light%2C%20minimal%20and%20dreamlike%2C%20cinematic%20wide%20composition&width=800&height=500&seq=news-c02&orientation=landscape",
    date: "2025-09-15",
    category: "影视资讯",
    tags: ["光年之外", "预告片", "科幻"],
    views: 25130,
    hot: 96,
    content: [
      { type: "p", text: "《光年之外》发布首支预告，短短两分钟内呈现了星际航行、失重舱室与孤独旅途等场景，整体视觉克制而富有诗意。" },
      { type: "h3", text: "再度合作的火花" },
      { type: "p", text: "这是筱田优与林澈继《无声告白》之后的第二次合作，两人在片中饰演一对在漫长旅途里彼此依靠的伙伴，情感层次较前作更进一层。" },
      { type: "p", text: "预告发布后迅速登上多个平台热搜，观众普遍对其美术与配乐给予好评，认为影片在类型表达上做出了新的尝试。" },
    ],
    relatedWorkIds: ["w7"],
  },
  {
    id: "n3",
    title: "筱田优获年度最佳女演员提名 演技再获肯定",
    excerpt: "凭借在《长夜将尽》与《春山可望》中的出色表现，筱田优入围年度最佳女演员提名名单。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20awards%20ceremony%20stage%20with%20warm%20golden%20spotlights%20and%20deep%20indigo%20curtains%2C%20luxurious%20and%20cinematic%20atmosphere%2C%20soft%20bokeh%20highlights%2C%20refined%20editorial%20photography&width=800&height=500&seq=news-c03&orientation=landscape",
    date: "2025-08-30",
    category: "影视动态",
    tags: ["提名", "奖项", "筱田优"],
    views: 16200,
    hot: 90,
    content: [
      { type: "p", text: "年度影视奖项公布提名名单，筱田优凭借《长夜将尽》入围最佳女演员，这也是她连续第二年获得该奖项提名。" },
      { type: "h3", text: "从作品出发的肯定" },
      { type: "p", text: "评审委员会在评语中提到，筱田优在角色塑造上展现出稳定的控制力，能够在极少的台词里完成情绪的层层递进。" },
    ],
    relatedWorkIds: ["w3", "w4"],
  },
  {
    id: "n4",
    title: "经典之作《无声告白》宣布重映 影迷重返影院",
    excerpt: "上映两周年之际，《无声告白》宣布推出修复重映版本，让更多观众有机会在大银幕上重温这部作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20cinema%20hall%20with%20warm%20projector%20light%20and%20empty%20red%20seats%2C%20nostalgic%20and%20quiet%20atmosphere%2C%20soft%20dust%20particles%20in%20the%20beam%2C%20cinematic%20retro%20photography&width=800&height=500&seq=news-c04&orientation=landscape",
    date: "2025-08-12",
    category: "影视资讯",
    tags: ["无声告白", "重映", "电影"],
    views: 12870,
    hot: 84,
    content: [
      { type: "p", text: "片方宣布《无声告白》将以修复重映版本与观众见面，画面与声音均经过重新处理，呈现出更细腻的质感。" },
      { type: "h3", text: "观众与作品的重逢" },
      { type: "p", text: "这部作品被视为筱田优表演生涯的重要转折点，她对角色内心挣扎的刻画至今仍被影迷反复讨论。" },
    ],
    relatedWorkIds: ["w1"],
  },
  {
    id: "n5",
    title: "《春山可望》口碑登顶 年代题材再掀讨论",
    excerpt: "剧集《春山可望》播出后评分持续走高，凭借扎实的剧本与细腻的表演成为今年讨论度最高的年代剧之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20countryside%20village%20in%20warm%20afternoon%20sunlight%20with%20rolling%20hills%20and%20old%20wooden%20houses%2C%20gentle%20amber%20and%20green%20tones%2C%20soft%20film%20grain%2C%20cinematic%20period%20drama%20still&width=800&height=500&seq=news-c05&orientation=landscape",
    date: "2025-07-25",
    category: "影视资讯",
    tags: ["春山可望", "电视剧", "口碑"],
    views: 20340,
    hot: 92,
    content: [
      { type: "p", text: "《春山可望》自开播以来口碑稳步上升，剧中细腻的家庭关系与时代变迁的刻画打动了不少观众。" },
      { type: "h3", text: "时间里的女性群像" },
      { type: "p", text: "筱田优在剧中饰演的角色跨越数十年，她用克制的表演呈现了一个普通女性在时代洪流中的坚韧与温柔。" },
    ],
    relatedWorkIds: ["w4"],
  },
  {
    id: "n6",
    title: "职场剧《逆风局》开播 筱田优演绎职场困境",
    excerpt: "由筱田优主演的都市职场剧《逆风局》正式开播，聚焦职场中的选择与坚持，首播即收获不错反响。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20interior%20with%20large%20windows%20and%20soft%20daylight%2C%20clean%20workspace%20with%20documents%20and%20a%20laptop%2C%20calm%20professional%20mood%2C%20neutral%20indigo%20and%20grey%20palette&width=800&height=500&seq=news-c06&orientation=landscape",
    date: "2025-07-06",
    category: "影视资讯",
    tags: ["逆风局", "开播", "职场"],
    views: 17650,
    hot: 86,
    content: [
      { type: "p", text: "《逆风局》以一个充满挑战的项目为切入点，讲述一群职场人在压力之下寻找自我价值的故事。" },
      { type: "h3", text: "真实感来自细节" },
      { type: "p", text: "为了更贴近真实的职场状态，主创团队走访了多个行业，筱田优也为此体验了不同岗位的日常工作节奏。" },
    ],
    relatedWorkIds: ["w8"],
  },
  {
    id: "n7",
    title: "专访筱田优：表演是一场持续靠近真实的旅程",
    excerpt: "在一次深度对话中，筱田优聊了聊她如何看待角色、表演与自我之间的关系，以及她选择作品的标准。",
    cover:
      "https://readdy.ai/api/search-image?query=Softly%20lit%20interview%20studio%20with%20a%20simple%20chair%20and%20warm%20backlight%2C%20calm%20and%20intimate%20mood%2C%20muted%20indigo%20background%20with%20gentle%20amber%20glow%2C%20editorial%20portrait%20setting&width=800&height=500&seq=news-c07&orientation=landscape",
    date: "2025-06-18",
    category: "人物访谈",
    tags: ["专访", "筱田优", "表演"],
    views: 21980,
    hot: 94,
    content: [
      { type: "p", text: "面对镜头之外的提问，筱田优依旧保持着她一贯的平静。她说，表演对她而言是一场持续靠近真实的旅程。" },
      { type: "h3", text: "关于角色的选择" },
      { type: "p", text: "谈到挑选作品的标准，她表示最在意的始终是人物是否足够立体，以及故事能否让她产生共鸣。" },
      { type: "p", text: "「我希望每一次出现，都能让观众看到一个不一样的我。」她说。" },
    ],
    relatedWorkIds: ["w1", "w4"],
  },
  {
    id: "n8",
    title: "《深海回响》海外发行启动 东方叙事走向国际",
    excerpt: "电影《深海回响》宣布启动海外发行计划，将在多个国家和地区的影院与流媒体平台陆续上线。",
    cover:
      "https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20soft%20blue%20light%20rays%20and%20gentle%20bubbles%2C%20serene%20and%20mysterious%20abstract%20world%2C%20rich%20indigo%20and%20teal%20tones%2C%20cinematic%20minimal%20composition&width=800&height=500&seq=news-c08&orientation=landscape",
    date: "2025-05-22",
    category: "影视动态",
    tags: ["深海回响", "海外发行", "电影"],
    views: 9870,
    hot: 72,
    content: [
      { type: "p", text: "《深海回响》以海洋为背景，讲述了一段关于记忆与寻找的故事，影片在视觉与声音设计上都极具作者风格。" },
      { type: "h3", text: "走向更远的观众" },
      { type: "p", text: "此次海外发行将覆盖多个地区，片方希望东方叙事能够被更多不同文化背景的观众所理解和喜爱。" },
    ],
    relatedWorkIds: ["w5"],
  },
  {
    id: "n9",
    title: "《归途列车》发布幕后特辑 揭秘拍摄日常",
    excerpt: "剧集《归途列车》释出幕后特辑，记录了主创团队在列车与城市之间辗转拍摄的真实状态。",
    cover:
      "https://readdy.ai/api/search-image?query=Train%20window%20view%20at%20dusk%20with%20blurred%20passing%20landscape%20and%20warm%20amber%20sunset%20light%2C%20lonely%20and%20reflective%20mood%2C%20soft%20film%20grain%2C%20cinematic%20travel%20still&width=800&height=500&seq=news-c09&orientation=landscape",
    date: "2025-05-02",
    category: "影视动态",
    tags: ["归途列车", "幕后", "花絮"],
    views: 8640,
    hot: 68,
    content: [
      { type: "p", text: "《归途列车》的幕后特辑展现了剧组在真实列车环境中拍摄的诸多不易，也让观众看到演员与工作人员之间的默契。" },
      { type: "h3", text: "在流动的空间里讲述故事" },
      { type: "p", text: "为了呈现旅途的真实质感，剧组选择在真实线路中取景，许多场景都是一次性完成的即兴捕捉。" },
    ],
    relatedWorkIds: ["w6"],
  },
  {
    id: "n10",
    title: "筱田优确认新作合作 题材聚焦现实议题",
    excerpt: "据片方透露，筱田优已确认出演一部聚焦现实议题的新片，影片将于年内开机。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20city%20street%20at%20blue%20hour%20with%20warm%20window%20lights%20and%20soft%20mist%2C%20reflective%20and%20calm%20urban%20atmosphere%2C%20muted%20indigo%20and%20amber%20tones%2C%20cinematic%20still&width=800&height=500&seq=news-c10&orientation=landscape",
    date: "2025-04-10",
    category: "影视动态",
    tags: ["新作", "合作", "筱田优"],
    views: 11230,
    hot: 76,
    content: [
      { type: "p", text: "片方透露，筱田优已确认加盟一部聚焦现实议题的新作，影片将围绕普通人的生活展开叙事。" },
      { type: "h3", text: "继续在真实中寻找力量" },
      { type: "p", text: "谈及这次合作，筱田优表示题材的真诚打动了她，她期待与新的团队碰撞出不一样的火花。" },
    ],
    relatedWorkIds: ["w7"],
  },
];